import { motion } from 'framer-motion';
import styled from 'styled-components';

import { GroupHeaderButton } from './GroupHeaderButton';
import { GroupHeaderFollowerInfo } from './GroupHeaderFollowerInfo';
import { GroupHeaderMembers } from './GroupHeaderMembers';

export const Root = styled.div<{ $hasExtraColumn?: boolean }>`
    &&& {
        display: grid;
        grid-template-columns: min-content 1fr;
        grid-template-areas: 'actions actions' 'image name' 'info info';
        gap: 10px 10px;
        align-items: start;
        width: 100%;
        padding-top: 0;
        position: relative;

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            padding-top: 20px;
            grid-template-areas: 'image name' 'image info';
            gap: 10px 30px;
        }
    }
`;

export const StyledImage = styled.div`
    &&& {
        grid-area: image;
        display: flex;
        align-items: flex-start;
    }
`;

export const StyledName = styled.div`
    &&& {
        grid-area: name;
        display: flex;
        align-self: center;
        align-items: center;
        gap: 10px;
    }
`;

export const EditableNameWrapper = styled.div`
    // Consider defaulting to '1 1 auto' to allow
    // full width on 'mobile'.
    flex: 0 0 auto;
`;

export const StyledInfo = styled.div`
    &&& {
        grid-area: info;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
`;

export const StyledActions = styled.div`
    &&& {
        grid-area: actions;
        display: flex;
        justify-content: space-between;
        padding-bottom: 15px;
    }
`;

export const StyledCta = styled(motion.div)`
    &&& {
        position: absolute;
        top: 6px;
        right: 0;
        min-height: 40px;
        svg {
            width: 24px;
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            position: static;
            top: unset;
            right: unset;
        }
    }
`;

export const StyledMembers = styled(GroupHeaderMembers)`
    &&& {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 7px;
    }
`;

export const EditingBackdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5;
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
`;

export const StyledFollowerInfo = styled(GroupHeaderFollowerInfo)`
    &&& {
        display: flex;
        align-items: center;
        gap: 7px;
        div {
            font-weight: 500;
            font-size: 14px;
        }
    }
`;

export const StyledFollowButton = styled(GroupHeaderButton)`
    &&& {
        padding: 15px 30px;
        position: relative;
        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            position: relative;
            padding: 13px 40px;
            gap: 10px;
            position: absolute;
            bottom: 0;
            right: 0;
        }
    }
`;

export const AddMembersWrapper = styled.div`
    position: relative;
`;
